import styled from '@emotion/styled'

import mirror from '@vio/atlas/src/utils/mirror'
import {cssTheme} from '@vio/atlas/themes'

const THUMBNAIL_IMAGE_SIZE = 60

export const SingleImagePanel = styled.div`
  flex: 1;
  .--motion-element {
    width: 100%;
    height: 100%;
  }
  &.--is-loading-state {
    height: 100%;
  }
`

export const CarouselWrapper = styled.div`
  position: relative;
  height: 100%;
`
export const SliderWrapper = styled.div`
  width: 100%;
  height: 100%;
  max-height: calc(100vh - ${cssTheme.layout.spacing.s900});
`

export const CarouselContainer = styled.div<{opacity: number}>`
  opacity: ${({opacity}) => opacity};
  height: 100%;
  width: 100%;
  position: absolute;
  overflow: hidden;
  top: 0;
`

export const ThumbnailsSection = styled.div`
  overflow: hidden;
  width: 100%;
`

export const ThumbnailImageWrapper = styled.div`
  height: ${THUMBNAIL_IMAGE_SIZE}px;
  width: ${THUMBNAIL_IMAGE_SIZE}px;
  min-width: ${THUMBNAIL_IMAGE_SIZE}px;

  cursor: pointer;
  overflow: hidden;
  display: flex;
  position: relative;
  border-radius: ${cssTheme.layout.radius.sm};

  &.--is-selected {
    outline: 4px solid ${cssTheme.colors.border.interactive.primaryActive};
  }
`

export const ImageDetailsWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: ${cssTheme.layout.spacing.s300} ${cssTheme.layout.spacing.s500};
  border-bottom: 1px solid ${cssTheme.colors.border.neutral.secondary};
  &.--has-category {
    justify-content: space-between;
  }
`

export const CarouselButtonWrapper = styled.div`
  ${mirror()}
  position: absolute;
  top: 0;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: ${cssTheme.layout.spacing.s400};
  width: 33%;
  &.--prev-button {
    left: 0;
    align-items: flex-start;

    [dir='rtl'] & {
      align-items: flex-end;
    }
  }
  &.--next-button {
    right: 0;
    align-items: flex-end;

    [dir='rtl'] & {
      align-items: flex-start;
    }
  }
`
export const BlurBackground = styled.div<{backgroundImage: string}>`
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: ${({backgroundImage}) => `url(${backgroundImage})`};
  background-size: 100% 100%;
  &::after {
    content: '';
    display: block;
    background-color: rgba(0, 0, 0, 0.25);
    width: 100%;
    height: 100%;
    backdrop-filter: blur(10px);
  }
`
